import React from 'react';
import PropTypes from 'prop-types';
import { className, renderText } from 'utils';

import styles from './subscribe.module.scss';
import ctaBaseStyles from '../ctaBase.module.scss';

const Subscribe = ({ headline, content }) => (
  <section
    {...className('component page-left-inset', ctaBaseStyles.cta, ctaBaseStyles.withBackground)}>
    <div className={ctaBaseStyles.row}>
      <div className={styles.copy}>
        {headline && <h1 className={styles.headline}>{headline}</h1>}
        {content && <p className={styles.description}>{renderText({ json: content })}</p>}
      </div>
    </div>
  </section>
);

Subscribe.propTypes = {
  headline: PropTypes.string,
  content: PropTypes.object,
};

export default Subscribe;
